import { Injectable, inject } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';
import * as AuthActions from './auth.actions';
import * as AuthSelectors from './auth.selectors';
import { OtpEventData } from '@piqet-angular/shared';

@Injectable()
export class AuthFacade {
  private readonly store = inject(Store);

  token$ = this.store.pipe(select(AuthSelectors.getAuthToken));
  isRegistered$ = this.store.pipe(select(AuthSelectors.getRegistrationStatus));
  isLoggedOut$ = this.store.pipe(select(AuthSelectors.getLogoutStatus));
  isLoggedIn$ = this.store.pipe(select(AuthSelectors.getLoginStatus));
  forgotPassword$ = this.store.pipe(select(AuthSelectors.getForgotPasswordData));
  resetPassword$ = this.store.pipe(select(AuthSelectors.getResetPasswordData));
  loginError$ = this.store.pipe(select(AuthSelectors.getLoginErrorMessage));
  otpVerifyError$ = this.store.pipe(select(AuthSelectors.getOtpErrorMessage));
  isForgotPassword$ = this.store.pipe(select(AuthSelectors.getForgotPasswordStatus));
  activationData$ = this.store.pipe(select(AuthSelectors.getActiveUserStatus));
  changePassword$ = this.store.pipe(select(AuthSelectors.getChangePAssworsdData));
  getIpAdress$ = this.store.pipe(select(AuthSelectors.getIpAdressData));
  sessionId$ = this.store.pipe(select(AuthSelectors.getSessionId));
  isShowOtpPage$ = this.store.pipe(select(AuthSelectors.getShowOtpPageFlag));
  getUserId$ = this.store.pipe(select(AuthSelectors.getUserId));
  isPasswordUpdated$ = this.store.pipe(select(AuthSelectors.isPasswordUpdated));
  //Facade for login user.
  login(payload: any) {
    this.store.dispatch(AuthActions.login({ payload }));
  }

  clearLoginData() {
    this.store.dispatch(AuthActions.clearLoginData());
  }
  clearMaxLoginAttempts() {
    this.store.dispatch(AuthActions.clearMaxLoginAttempts());
  }

  //Facade for register user.
  register(payload: any, purchaseType: any) {
    this.store.dispatch(AuthActions.register({ payload, purchaseType }));
  }

  //Facade for logout user.
  logout() {
    this.store.dispatch(AuthActions.logout());
  }

  //Facade for forgotPassword user.
  forgotPassword(payload: any) {
    this.store.dispatch(AuthActions.forgotPassword({ payload }));
  }

  //Facade for forgotPassword user.
  resetPassword(payload: any) {
    this.store.dispatch(AuthActions.resetPassword({ payload }));
  }

  clearError() {
    this.store.dispatch(AuthActions.clearErrorMessage());
  }

  getIpAdress() {
    this.store.dispatch(AuthActions.getIpAddress());
  }

  activeUser(payload: any) {
    this.store.dispatch(AuthActions.activeUser({ payload }));
  }

  activeUserByTrialCode(payload: any) {
    this.store.dispatch(AuthActions.activeUser({ payload, activationType: 'trialCode' }));
  }
  // For UID activation
  activeUserByUID(uid: string) {
    this.store.dispatch(AuthActions.activeUser({ payload: uid, activationType: 'uid' }));
  }

  changePassword(payload: any) {
    this.store.dispatch(AuthActions.changePassword({ payload }));
  }

  payment(payload: any) {
    this.store.dispatch(AuthActions.payment({ payload }));
  }

  loginWithAzure(profile: any, token: any, isFlag: any, isLogin: any) {
    this.store.dispatch(
      AuthActions.loginSuccess({
        profile: profile,
        tokenClaim: token,
        isLoggedIn: isLogin,
        isFlag: isFlag,
      })
    );
  }

  showOtpPage(showOtpPage: boolean) {
    this.store.dispatch(AuthActions.showOtpPage({ showOtpPage }));
  }

  verifyOtp(payload: OtpEventData, ipAddress: any) {
    this.store.dispatch(
      AuthActions.verifyOtp({ otpNumber: payload.otp, userId: payload.userId, ipAddress })
    );
  }

  clearVerifyError() {
    this.store.dispatch(AuthActions.clearVerifyError());
  }
  clearLoginMessageError() {
    this.store.dispatch(AuthActions.clearLoginMessageError());
  }
  passwordUpdated() {
    this.store.dispatch(AuthActions.passwordUpdated());
  }
}
